import { SET_FILTER, RESET_FILTERES, SET_FILTERS } from "./constants";
import { setFiltered } from "../filtered";
import queryString from "query-string";

export const setUrlQuery = () => (dispatch, getState) =>
	new Promise(resolve => {
		const { filters, helpers } = getState();
		const { building } = helpers;

		const currentFilters = filters[building];
		// console.log(currentFilters);
		window.location.search = Object.keys(currentFilters)
			.reduce((all, name) => {
				const filter =
					typeof currentFilters[name] === "string"
						? currentFilters[name]
						: currentFilters[name].join(",");
				if (filter.length > 0) {
					all.push(`${name}=${filter}`);
				}
				return all;
			}, [])
			.join("&");
	});

export const setFilters = search => (dispatch, getState) =>
	new Promise(resolve => {
		const { helpers, canvas, filters } = getState();
		const { hasFloors } = canvas[helpers.building];
		if(search.length > 3) {
			const query = search.substr(1).replace(/%20/u, " ").split("&").map(item => item.split("="));
			if (query.length > 0) {
				query.forEach(item => {
					const filter = item[0];
					const value = item[1].split(",");
					filters[helpers.building][filter] = value;
					if (item === "floor" && hasFloors) {
						filters[helpers.building][filter] = item[1];
					}
				});
				dispatch({
					type: SET_FILTERS,
					filters
				});
				dispatch(setFiltered());
			}
		}
		resolve(true);
	});

export const reset = type => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: RESET_FILTERES,
			building
		});
		dispatch(setFiltered());
		resolve(type);
	});

export const setType = type => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_FILTER,
			value: type,
			filterName: "type",
			filterType: "checkbox",
			building
		});
		dispatch(setFiltered());
		resolve(type);
	});
export const setFloor = (floor, type) => (dispatch, getState) =>
	new Promise(resolve => {
		const { building, hasFloors } = getState().helpers;

		dispatch({
			type: SET_FILTER,
			value: floor,
			filterName: "floor",
			filterType: type,
			building
		});
		dispatch(setFiltered());
		resolve(floor);
	});
export const setSurface = surface => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_FILTER,
			value: surface,
			filterName: "surface",
			filterType: "range",
			building
		});
		dispatch(setFiltered());
		resolve(surface);
	});
export const setPrice = price => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_FILTER,
			value: price,
			filterName: "price",
			filterType: "range",
			building
		});
		dispatch(setFiltered());
		resolve(price);
	});
export const setBenefit = benefit => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_FILTER,
			value: benefit,
			filterName: "benefits",
			filterType: "checkbox",
			building
		});
		dispatch(setFiltered());
		resolve(benefit);
	});
